/** 与 cool-admin ANDROID_TEMPLATE_LANGUAGES 及 project 常见系统语言对齐 */
export const SUPPORTED_LOCALES = [
  'zh',
  'en',
  'zh-TW',
  'ja',
  'ko',
  'es',
  'fr',
  'de',
  'pt',
  'ru',
  'vi',
  'th',
  'id'
];

/** Android / BCP47 → H5 locale */
const LOCALE_ALIASES = {
  'zh-cn': 'zh',
  'zh-hans': 'zh',
  'zh-sg': 'zh',
  'zh-tw': 'zh-TW',
  'zh-hk': 'zh-TW',
  'zh-mo': 'zh-TW',
  'zh-hant': 'zh-TW',
  'pt-br': 'pt',
  'pt-pt': 'pt',
  in: 'id',
  iw: 'he',
  he: 'en',
  nl: 'de',
  it: 'es',
  pl: 'de',
  tr: 'de',
  ar: 'en',
  hi: 'en',
  bn: 'en',
  ms: 'id',
  fil: 'en',
  tl: 'en'
};

export function isSupportedLocale(code) {
  return SUPPORTED_LOCALES.includes(code);
}

export function normalizeH5Locale(code) {
  const raw = String(code || '')
    .trim()
    .toLowerCase()
    .replace(/_/g, '-');
  if (!raw) return 'en';
  if (isSupportedLocale(raw)) return raw;
  if (LOCALE_ALIASES[raw]) {
    const mapped = LOCALE_ALIASES[raw];
    return isSupportedLocale(mapped) ? mapped : 'en';
  }
  const base = raw.split('-')[0];
  if (isSupportedLocale(base)) return base;
  if (base === 'zh') {
    if (raw.includes('tw') || raw.includes('hk') || raw.includes('hant')) {
      return 'zh-TW';
    }
    return 'zh';
  }
  if (LOCALE_ALIASES[base]) {
    const mapped = LOCALE_ALIASES[base];
    return isSupportedLocale(mapped) ? mapped : 'en';
  }
  return 'en';
}

export function detectLocaleFromNavigator() {
  try {
    const langs = [];
    if (typeof navigator !== 'undefined') {
      if (navigator.language) langs.push(navigator.language);
      if (navigator.languages?.length) langs.push(...navigator.languages);
    }
    for (const item of langs) {
      const locale = normalizeH5Locale(item);
      if (locale) return locale;
    }
  } catch (_) {
    /* ignore */
  }
  return 'en';
}

export function htmlLangAttr(locale) {
  const map = {
    zh: 'zh-CN',
    'zh-TW': 'zh-TW',
    en: 'en',
    ja: 'ja',
    ko: 'ko',
    es: 'es',
    fr: 'fr',
    de: 'de',
    pt: 'pt',
    ru: 'ru',
    vi: 'vi',
    th: 'th',
    id: 'id'
  };
  return map[locale] || locale || 'en';
}
